import { useContext } from "react";

import ShipmentConceptContext from "../context/ShipmentConceptContext";

const useShipmentConcept = () => useContext(ShipmentConceptContext);

export default useShipmentConcept;
